module.exports = __webpack_public_path__ + "static/media/default-plan.c991dc08.jpg";